

















































































































































































import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import { Individu } from "@/models/Individu";
import pointageScrollbar from "./components/pointage-scrollbar.vue";
import pointageList from "./components/pointage-list.vue";
import pointageSelectionHeure from "@/features/pointages/pointages-heure/components/pointage-selection-heure.vue";
import { Pointage } from "@/models/Pointage";
import { utils } from "@/util";
import { TarifEventSchedulerActiviteDocument } from "@/models/TarifEventSchedulerActiviteDocument";
import { VieQuotidienneDocuments } from "@/models/VieQuotidienneDocument";
import { PaletteDocument } from "@/models/PaletteDocument";
import FiltreBox from "@/components/app-filtres/components/box.vue";
import { SHOW_LOADING, CLOSE_LOADING } from "@/store/types";
import { TarifActiviteDocument } from "@/models/TarifActiviteDocument";
import AppLockPointage from "@/components/app-lockpointage.vue";
import router from "@/router";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import { FiltrePointage } from "@/models/_FiltresPointage";
export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    store.dispatch(SHOW_LOADING);
    store.dispatch("individus/fetchDataForFilter").catch((error: any) => {
      store.dispatch(CLOSE_LOADING);
    });
    store
      .dispatch("individus/fetchListIndividus", "activite")
      .then(() => {
        store
          .dispatch("pointages/fetchAll")
          .then(() => {
            next((vm: any) => {
              store.dispatch(CLOSE_LOADING);
              vm.initScolariteFilter();
              vm.initPointageFilter();
              next();
            });
          })
          .catch((error: any) => {
            store.dispatch(CLOSE_LOADING);
            next("/erreurs/" + error);
          });
      })
      .catch((error: any) => {
        store.dispatch(CLOSE_LOADING);
        next("/erreurs/" + error);
      });
  },
  beforeRouteLeave(to, from, next) {
    store
      .dispatch("individus/closeFiltre", "all")
      .then(() => {
        next();
      })
      .catch((error: any) => {
        next("/erreurs/" + error);
      });
  },
  components: {
    AppLayout,
    pointageScrollbar,
    pointageList,
    pointageSelectionHeure,
    FiltreBox,
  },
  data() {
    return {
      modalCurrentTime: "",
      modalMaxTime: "",
      modalMinTime: "",
      showModal: false,
      currentPointage: {},
      pointageType: "",
      isPointageGlobal: false,
      currentIndividu: {},
      currentIndividuName: "",
      currentTemps: {},
      hasHeureFix: false,
      currentSupplement: {},
      showModalReserv: false,
      showModalPointage: false,
      showModalSupplements: false,
      filtredTempsAccueil: [] as Array<number>,
      filtredSupplements: [] as Array<number>,
      autori: -2,
      alphabet: [...Array(26)]
        .map((_, y) => String.fromCharCode(y + 65))
        .join(""),
      selectedPageSize: 999,
      currentPage: 1,
      maxPage: 1,
      paginatedIndividus: [] as Array<Individu>,
      activeLettre: [] as Array<string>,
      filtreScolarite: new FiltreScolarite(),
      filtrePointage: new FiltrePointage(),
    };
  },
  computed: {
    ...mapGetters("individus", [
      "getFiltredListIndividus",
      "getListClasses",
      "getListEcoles",
      "getListInstits",
      "getListNiveau",
      "getListVille",
      "getCurrentAnneeScolaire",
      "getListEtablissementScolaireNiveau",
      "getListClasseScolaireNiveau",
      "getListClasseScolaireEnseignant",
      "getListIndividus",
    ]),
    ...mapGetters("pointages", [
      "getPointageEnCours",
      "getListTempsAccueil",
      "getListTempsAccueilFiltred",
      "getListPointagesPrevi",
      "getListSupplements",
      "getSupplementsActifs",
      "getLastAction",
      "getPaletteEnCours",
      "getListPalettePresence",
      "getListPaletteAbsence",
      "getListGroupes",
      "getListRegim",
      "getListSupplementsPrevi",
      "getIndividusPresents",
      "getVieQuoRegimeAli",
      "getIndividusFiltreesPresents",
    ]),
    ...mapGetters("etablissements", ["getCurrentEtablissement"]),
    ...mapGetters("activites", [
      "getDate",
      "getCurrentActivite",
      "getIsDateDiff",
    ]),
    ...mapGetters("session", [
      "getLocalDBStatus",
      "storeWillUpdate",
      "getMemDBStatus",
    ]),
  },
  mounted() {
    this.filtredTempsAccueil = this.getListTempsAccueilFiltred.map((temps: any) =>
      temps.getId()
    );
    this.filtredSupplements = this.getListSupplements.map((supp: any) =>
      supp.getId()
    );

    this.currentPage = 1;
    this.maxPage = utils.calculateMaxPage(
      this.getFiltredListIndividus as Array<Individu>,
      this.selectedPageSize
    );

    this.paginatedIndividus = utils.paginate(
      this.getFiltredListIndividus,
      this.selectedPageSize,
      this.currentPage
    );
    this.activeLettre = [
      ...new Set(
        this.paginatedIndividus.map((ind: Individu) => ind.getDisplayName()[0])
      ),
    ];
  },
  methods: {
    filtreAutori(e: number) {
      console.log(e);
      this.autori = e;
    },
    selectEnfant(enfant: Individu) {
      store.dispatch("individus/selectIndividu", enfant);
    },
    undoLastAction() {
      store.dispatch("pointages/undoLastAction");
    },
    countRegim() {
      let regimCount = [] as Array<any>;
      this.getListRegim.forEach((regim: VieQuotidienneDocuments) => {
        let total: number = 0;
        total = this.getFiltredListIndividus.reduce(
          (acc: number, individu: Individu) =>
            individu.getRegimealimentaire_id() === regim.getId()
              ? (acc += 1)
              : (acc += 0),
          total
        );
        regimCount.push({
          regim_id: regim.getVieQuoRegimeAli().getType_regime(),
          count: total,
        });
      });
      return regimCount;
    },
    closeFiltre(params: string) {
      if (params === "all") {
        store.dispatch("individus/closeFiltre", params);
        this.filtredTempsAccueil = this.getListTempsAccueil.map((temps: any) =>
          temps.getId()
        );
        this.filtredSupplements = this.getListSupplements.map((supp: any) =>
          supp.getId()
        );
        store.dispatch("pointages/filterListTempsAccueil");
        store.dispatch("pointages/filterListSupplement");
      } else {
        if (params !== "temps") {
          store.dispatch("individus/closeFiltre", params);
          
        } else {
          store.dispatch("pointages/filterListTempsAccueil");
        store.dispatch("pointages/filterListSupplement");
          this.filtredTempsAccueil = this.getListTempsAccueilFiltred.map(
            (temps: any) => temps.getId()
          );
          this.filtredSupplements = this.getListSupplements.map((supp: any) =>
            supp.getId()
          );
        }
      }
    },
    currentPalette(palette: PaletteDocument) {
      store.dispatch("pointages/setPaletteEncours", palette);
    },

    addPointageHoure(idIndividu: number) {
      store.dispatch("pointages/addPointageHeure", idIndividu);
    },
    filtres(params: any) {
      console.log("params", params);
      if (typeof params === "undefined" || params.filtre !== "temps") {
        store.dispatch("individus/filtreListIndividus", params);
      } else {
        store.dispatch("pointages/filterListTempsAccueil", params.value[0]).then(()=>{
        });
        store.dispatch("pointages/filterListSupplement", params.value[1]);
        /*this.filtredTempsAccueil = params.value[0];
        this.filtredSupplements = params.value[1];*/
      }
    },
    pointerArrivee(e: any) {
      store.dispatch("pointages/addPointageArrivee", e);
    },
    pointerDepart(e: any) {
      store.dispatch("pointages/addPointageDepart", e);
    },
    showPointageMasseModal(temps: TarifEventSchedulerActiviteDocument) {
      this.currentTemps = temps;
      this.showModalPointage = true;
    },
    showSupplementsMasseModal(suppl: TarifActiviteDocument) {
      this.currentSupplement = suppl;
      this.showModalSupplements = true;
    },
    showPointageModal(e: any) {
      this.modalCurrentTime = e[1];
      this.currentPointage = e[0];
      this.pointageType = e[2];
      this.currentIndividuName = e[3];
      this.currentTemps = e[4];
      this.currentIndividu = e[5];
      this.findMaxAndMinTime();
      this.isPointageGlobal = false;
      this.showModal = true;
    },
    findMaxAndMinTime() {
      let pointage: Pointage = new Pointage(this.currentPointage);
      let temps: TarifEventSchedulerActiviteDocument =
        new TarifEventSchedulerActiviteDocument(this.currentTemps);
      this.hasHeureFix = false;
      if (this.pointageType === "arrivée") {
        this.modalMaxTime = temps.getStart_date();
        if (pointage.getTempsFin() === "") {
          this.modalMinTime = temps.getEnd_date();
        } else {
          this.modalMinTime = pointage.getTempsFin();
        }
      } else if (this.pointageType === "départ") {
        this.modalMinTime = temps.getEnd_date();
        if (pointage.getTempsDebut() === "")
          this.modalMaxTime = temps.getStart_date();
        else this.modalMaxTime = pointage.getTempsDebut();
      } else {
        this.showModal = false;
      }
    },
    findMaxAndMinTimeGlobal() {
      /*
      Si un pointage arrivé il faut définir le max selon le pointage départ le plus tot
      si un pointage départ il faut définir le pointage min selon le pointage arrivé le plus tard
      */
      let temps = this.currentTemps as TarifEventSchedulerActiviteDocument;
      this.modalMaxTime = temps.getStart_date();
      this.modalMinTime = temps.getEnd_date();
      let currentPointage = this.getPointageEnCours as Array<Pointage>;
      this.hasHeureFix = false;
      currentPointage = currentPointage.filter((item: Pointage) => {
        return (
          item.getElementFriseId() === temps.getFriseElement_id() &&
          item.getTempsFin() === ""
        );
      });
      if (this.pointageType === "arrivée") {
        if (temps.getHeure_debut_fixe()) this.hasHeureFix = true;
        let times = currentPointage
          .map(function (el: any) {
            return el.getTempsFin();
          })
          .filter((item: string) => {
            return item !== "";
          });
        console.log(times);
        if (times.length !== 0) {
          times.forEach((t: string) => {
            if (this.modalMinTime > t) this.modalMinTime = t;
          });
        }
      } else if (this.pointageType === "départ") {
        console.log(temps);
        if (temps.getHeure_fin_fixe()) this.hasHeureFix = true;
        let times = currentPointage.map(function (el: any) {
          return el.getTempsDebut();
        });
        if (times.length !== 0) {
          times.forEach((t: string) => {
            if (this.modalMaxTime < t) this.modalMaxTime = t;
          });
        }
      }
    },
    closeModal() {
      this.showModal = false;
    },
    editPointage(e: string) {
      if (this.isPointageGlobal) {
        console.log("isPointageGlobal");
        this.showModal = false;
        if (this.pointageType === "arrivée")
          store.dispatch("pointages/addPointageArriveeGlobal", [
            this.pointageType,
            this.currentTemps,
            e,
          ]);

        if (this.pointageType === "départ")
          store.dispatch("pointages/addPointageDepartGlobal", [
            this.pointageType,
            this.currentTemps,
            e,
          ]);
      } else {
        this.showModal = false;

        store.dispatch("pointages/editPointage", [
          this.pointageType,
          this.currentPointage,
          e,
        ]);
      }
    },
    pointageGlobal(e: any) {
      this.pointageType = e[2];
      this.currentTemps = e[0];
      this.modalCurrentTime = e[1];
      this.isPointageGlobal = true;
      this.findMaxAndMinTimeGlobal();
      this.showModal = true;
    },
    confReservation() {
      store.dispatch("pointages/confReservation", [
        this.filtredTempsAccueil,
        this.filtredSupplements,
      ]);
      this.showModalReserv = false;
    },
    effacerPointage() {
      this.showModal = false;

      store.dispatch("pointages/removePointage", [
        this.currentPointage,
        this.pointageType,
      ]);
    },
    effacerPointages() {
      this.showModal = false;

      store.dispatch("pointages/removeAllPointages", [
        this.currentTemps,
        this.pointageType,
      ]);
    },
    pointerTS(e: any) {
      store.dispatch("pointages/addPointageTS", e);
    },
    removePointageTS(e: any) {
      store.dispatch("pointages/removePointageTS", e);
    },
    pointageTSGlobal(e: any) {
      store.dispatch("pointages/pointageTSGlobal", this.currentTemps);
      this.showModalPointage = false;
    },
    pointerSupplement(e: any) {
      store.dispatch("pointages/addSupplement", e);
    },
    removeSupplement(e: any) {
      store.dispatch("pointages/removeSupplementHeure", e);
    },
    pointageSupplementGlobal() {
      store.dispatch("pointages/addSupplementMasse", this.currentSupplement);
      this.showModalSupplements = false;
    },
    showListeUrgence(filtred: string) {
      router.push({
        name: "ListIndividusUrgence",
        params: { filtred: filtred },
      });
    },
    showInfos(event: any) {
      let now = utils.getDateFromString(event, "YYYY-MM-DD");
      if (
        this.getCurrentActivite
          .getJours()
          .toLowerCase()
          .includes(now.format("dddd").slice(0, 2))
      ) {
        store.dispatch("activites/setCurrentDate", event);
        store.dispatch(SHOW_LOADING);
        store.dispatch("individus/fetchListIndividus", "activite").then(() => {
          store
            .dispatch("pointages/fetchAll")
            .then(() => {
              store.dispatch(CLOSE_LOADING);
              this.initScolariteFilter();
              this.initPointageFilter();
            })
            .catch((error: any) => {
              store.dispatch(CLOSE_LOADING);
              router.push("/erreurs/" + error);
            });
        });
      } else {
        router.push("/erreurs/no-seances-found");
      }
    },
    nextPage() {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
        this.paginatedIndividus = utils.paginate(
          this.getFiltredListIndividus,
          this.selectedPageSize,
          this.currentPage
        );
        this.activeLettre = [
          ...new Set(
            this.paginatedIndividus.map(
              (ind: Individu) => ind.getDisplayName()[0]
            )
          ),
        ];
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginatedIndividus = utils.paginate(
          this.getFiltredListIndividus,
          this.selectedPageSize,
          this.currentPage
        );
        this.activeLettre = [
          ...new Set(
            this.paginatedIndividus.map(
              (ind: Individu) => ind.getDisplayName()[0]
            )
          ),
        ];
      }
    },
    changePageSize(size: number) {
      this.selectedPageSize = size;
      this.currentPage = 1;
      this.maxPage = utils.calculateMaxPage(
        this.getFiltredListIndividus as Array<Individu>,
        this.selectedPageSize
      );
      this.paginatedIndividus = utils.paginate(
        this.getFiltredListIndividus,
        this.selectedPageSize,
        this.currentPage
      );
      this.activeLettre = [
        ...new Set(
          this.paginatedIndividus.map(
            (ind: Individu) => ind.getDisplayName()[0]
          )
        ),
      ];
    },
    hasPuce(individu: Individu) {
      if (typeof individu === "undefined" || this.isPointageGlobal) return false;
      return (this.getPointageEnCours as Array<Pointage>).some(
        (item: Pointage) =>
          item.getIdIndividu() === individu.getId() &&
          item.getTempsFin() === "" &&
          item.getElementFriseId() !==
            (this.currentPointage as Pointage).getElementFriseId()
      );
    },
    initScolariteFilter() {
      this.filtreScolarite.setListClasses(this.getListClasses);
      this.filtreScolarite.setListEtablissementScolaireNiveau(
        this.getListEtablissementScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireNiveau(
        this.getListClasseScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireEnseignant(
        this.getListClasseScolaireEnseignant
      );
      this.filtreScolarite.setListEcoles(this.getListEcoles);
      this.filtreScolarite.setListInstits(this.getListInstits);
      this.filtreScolarite.setListNiveau(this.getListNiveau);
      this.filtreScolarite.setCurrentAnneeScolaire(
        this.getCurrentAnneeScolaire
      );
    },
    initPointageFilter() {
      this.filtrePointage.setListTemps(this.getListTempsAccueil);
      this.filtrePointage.setPalettepresence(this.getListPalettePresence);
      this.filtrePointage.setPaletteabsence(this.getListPaletteAbsence);
      this.filtrePointage.setListGroupes(this.getListGroupes);
      this.filtrePointage.setListSuppplements(this.getListSupplements);
    },
  },
  watch: {
    getListTempsAccueilFiltred(
      newVal: Array<TarifEventSchedulerActiviteDocument>,
      oldVal: Array<TarifEventSchedulerActiviteDocument>
    ) {
      this.filtredTempsAccueil = newVal.map((temps: any) => temps.getId());
    },
    getListSupplements(
      newVal: Array<TarifActiviteDocument>,
      oldVal: Array<TarifActiviteDocument>
    ) {
      this.filtredSupplements = this.getListSupplements.map((supp: any) =>
        supp.getId()
      );
    },
    getLocalDBStatus(newVal: string, oldVal: string) {
      if (oldVal === "change" && newVal === "paused") {
        // store.dispatch("pointages/resetLastAction");
        store.dispatch("pointages/fetchListPointages").then((rep: any) => {
          store.dispatch("pointages/fetchSupplementActifs");
        });
      }
    },
    storeWillUpdate(newVal: string, oldVal: string) {
      if (!newVal && oldVal) {
        //store.dispatch("pointages/resetLastAction");
        store.dispatch(SHOW_LOADING);
        store.dispatch("individus/fetchDataForFilter");
        store
          .dispatch("individus/fetchListIndividus", "activite")
          .then(() => {
            store
              .dispatch("pointages/fetchAll")
              .then(() => {
                store.dispatch(CLOSE_LOADING);
                this.initScolariteFilter();
                this.initPointageFilter();
              })
              .catch((error: any) => {
                store.dispatch(CLOSE_LOADING);
                router.push("/erreurs/" + error);
              });
          })
          .catch((error: any) => {
            store.dispatch(CLOSE_LOADING);
            router.push("/erreurs/" + error);
          });
      }
    },
    getFiltredListIndividus(newVal: Array<Individu>, oldVal: Array<Individu>) {
      this.currentPage = 1;
      this.maxPage = utils.calculateMaxPage(
        newVal as Array<Individu>,
        this.selectedPageSize
      );

      this.paginatedIndividus = utils.paginate(
        newVal,
        this.selectedPageSize,
        this.currentPage
      );
      this.activeLettre = [
        ...new Set(
          this.paginatedIndividus.map(
            (ind: Individu) => ind.getDisplayName()[0]
          )
        ),
      ];
    },
  },
});
